module.exports = __webpack_public_path__ + "media/images/components/map-icons/contacts-map-pin-elector-47548329ec5adc46187851f7eda749a6.png";